import React from "react";
import Loadable from "../../react-loadable";
import "./style/index.css";

const WeaField = Loadable({
  loader: () => import("./Field"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});

export default WeaField;



// WEBPACK FOOTER //
// ./ecology9/wea-field/index.js